define('ch_grouper',[
    'ch_ga',
    'jquery',
    'semantic',
], function (ga, $) {
    function initializeGrouperIntentModal($grouperModal) {
        const $grouperForm = $('.ui.form', $grouperModal);

        $grouperForm.form({
            on: 'change',
            inline: true,
            fields: {
                group_size: {
                    rules: [
                        {
                            type: 'empty',
                            prompt: "Please enter your group's size.",
                        },
                        {
                            type: 'integer[1..100]',
                            prompt: 'Please only enter numbers from 1 to 100',
                        },
                    ],
                },
            },
            onSubmit: e => e.preventDefault(),
        });

        $('.dropdown', $grouperForm)
            .dropdown();

        // grouper cta that displays the grouper intent modal
        // expects a "data-ga-event" attribute, which is sent to GA when user submits the modal
        // and a "data-ga-cta-label" attribute, which is used when the user clicks the CTA that opens the modal
        $('a.js-grouper-modal')
            .on('click', e => {
                e.preventDefault();

                // @deprecated event
                // kept around for continuity for Katie while testing Grouper (Feb 11 2020)
                ga(
                    'send',
                    'event',
                    'Grouper',
                    'viewed nav site pop-up',
                    window.location.pathname,
                    { nonInteraction: false }
                );
                // newer event versus "viewed nav site pop-up"
                triggerEventOnElement(e.currentTarget);

                let href = e.currentTarget.href;
                let gaEvent = e.currentTarget.dataset.gaEvent;

                $grouperModal
                    .modal({
                        onShow: () => {
                            $grouperForm.form('reset');
                        },
                        onApprove: () => {
                            let isFormValid = $grouperForm.form('is valid');
                            if (!isFormValid) {
                                $grouperForm.form('validate form');
                                return false;
                            }
                            let viewingCourseId = (CH && CH.courseId) || 'NA';
                            let formData = $grouperForm.form('get values');
                            let groupSize = formData.group_size;
                            let [url, search = ''] = href.split('?');
                            let gaAction = `${window.location.pathname} - ${viewingCourseId};${groupSize}`;

                            search = search.split('&');
                            search.push(`groupSize=${groupSize}`);

                            // If the user is currently viewing a category browse page
                            // we want to preserve that too
                            if (CH && CH.activeMainCategoryId) {
                                search.push(`categories=${CH.activeMainCategoryId}`);
                            }

                            $.ajax('/user/subscription/grouper-intent', {
                                method: 'POST',
                                data: {
                                    group_size: formData.group_size,
                                    url: window.location.pathname + window.location.search,
                                },
                            })
                                .done(() => {
                                    ga(
                                        'send',
                                        'event',
                                        'Grouper',
                                        gaEvent,
                                        gaAction,
                                        { nonInteraction: false }
                                    );

                                    if (CH && CH.Hub && CH.Hub.uri && CH.Hub.uri !== 'nyc') {
                                        // send new market visitors to our private events page instead of grouper
                                        window.location.assign('/private-events');
                                    } else {
                                        // send NYC visitors to the defined URL; probably grouper
                                        window.location.assign(url + '?' + search.join('&'));
                                    }
                                });
                            return true;
                        },
                        onHide: () => {
                            ga(
                                'send',
                                'event',
                                'Grouper',
                                'dismissed nav site pop-up',
                                window.location.pathname,
                                { nonInteraction: false }
                            );
                        },
                    })
                    .modal('show');
            });
    }

    function triggerEvent(gaAction, nonInteraction = false) {
        let gaLabel = window.location.pathname;

        if (window.CH && window.CH.courseId) {
            gaLabel += ' - ' + window.CH.courseId;
        }

        ga(
            'send',
            'event',
            'Grouper',
            gaAction,
            gaLabel,
            { nonInteraction: nonInteraction }
        );
    };

    /**
     * Trigger a Grouper CTA GA Event for a given element
     * expects element to define:
     *  data-ga-cta-label
     *
     * Ga Event:
     *  Category: Grouper
     *  Action: CTA ${data-ga-event}
     *  Label: ${URL}-${COURSE_ID_IF_AVAILBLE}
     *
     * @param element
     * @param nonInteraction
     */
    function triggerEventOnElement(element, nonInteraction = false) {
        let gaAction = element.dataset.gaCtaLabel || 'CTA ...';

        triggerEvent(gaAction, nonInteraction);
    };

    return {
        triggerEventOnElement,
        triggerEvent,
        initializeGrouperIntentModal,
    };
});

